import { FC } from 'react';
import { Outlet } from 'react-router-dom';

import styled from '../../styled';

const CenteringDiv = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: var(--max-width);
`;

// Component to center Balder pages within the old design.
// TODO: Remove this component when the old design is removed.
const CenteringContainer: FC = () => {
  const isBalderDesign = window.config.VITE_BALDER_DESIGN_ENABLED;

  if (isBalderDesign) {
    return <Outlet />;
  }

  return (
    <CenteringDiv>
      <Outlet />
    </CenteringDiv>
  );
};

export default CenteringContainer;
